import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function Pagination() {
    const { videos } = useSelector(state => state.videos);
    const { page = 1 } = useParams();
    return (
        <section className="pt-12">
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
                <Link to="/">
                    <div className={`px-4 py-1 rounded-full ${page === 1 ? "bg-blue-600 text-white" : "bg-blue-100 text-blue-600"}`}>
                        1
                    </div>
                </Link>
                <CreatePagination length={videos.length} page={page} />
            </div>
        </section>
    );
}

const CreatePagination = ({ length, page }) => {
    const navigate = useNavigate();
    const pagination = [];

    for (let i = 2; i <= Math.ceil(length / 2); i++) {
        pagination.push(<Link key={i} to={`/${i}`}>
            <div className={`px-4 py-1 rounded-full ${parseInt(page) === i ? "bg-blue-600 text-white" : "bg-blue-100 text-blue-600"}`}>
                {i}
            </div>
        </Link>)
    };

    useEffect(() => {
        if (page > Math.ceil(length / 2)) {
            navigate("/");
        }
    }, [navigate, page, length])


    return pagination

}